// extracted by mini-css-extract-plugin
module.exports = {"backgroundColor":"_1yZItSD4MADx","content":"sQg4kWq_sap-"};